<template>
    <table-page
        @update:topBut="topBut"
        @update:nodeBut="nodeBut"
        @update:handleSelectionChange="handleSelectionChange"
        :but-no-manage="noManage"
        ref="tablePageRef">
        <menus ref="menusRef" :params="{'m': 'store'}" :data-url="menusUrl" @update:onUrlChange="onUrlChange"></menus>
        <form-page
            v-if="isload"
            :page-type="pageInfo.page_type"
            :title="pageTitle"
            :pageInfo="pageInfo"
            :forms="formobj"
            @update:onSubmit="onSubmit">
            <template #form_top>
                <el-button type="warning" @click="menusToForm">系统连接</el-button>
            </template>
        </form-page>
    </table-page>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive, onMounted } from 'vue'
    import TablePage from '../../common/table'
    import Menus from '../../common/menus'
    import FormPage from '@/components/ui-form-page'
    import { Host } from '@/config/index'

    export default defineComponent({
        components: {
            TablePage,
            FormPage,
            Menus
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const query = reactive(proxy.$router.currentRoute.value.query)
            const selectIds = ref()
            const urls = proxy.$router.currentRoute.value.meta.urls
            const noManage = ['topAdd', 'nodeAdd', 'nodeEdit', 'autoGetList']

            const tablePageRef = ref()
            const formTitle = ref()
            const addFormRef = ref()

            const isload = ref(false)
            const pageTitle = ref()
            const formobj = ref({})
            const pageInfo = ref()
            const dialogFormVisible = ref(false)
            const dialogMenusVisible = ref(false)
            const menusRef = ref()
            const menusUrl = `${Host}store/shared/menu/menus`
            const appType = ref()
            const postUrl = ref()
            const onUrlChange = (e) => {
                formobj.value.map((item) => {
                    if (item.name === 'title') {
                        item.value = e.name
                    }
                    if (item.name === 'url') {
                        item.value = e.url
                    }
                })
                dialogMenusVisible.value = false
            }

            const topBut = (e) => {
                if (e === 'Add') {
                    postUrl.value = urls.add
                    getInfo()
                }
            }

            const getInfo = (map = {}, url = urls.add) => {
                let mapObj = Object.assign(map, query)
                isload.value = false
                proxy.jiu.request(url, mapObj).then((res, rej) => {
                    formobj.value = res.data.form_items
                    pageInfo.value = res.data
                    isload.value = true
                    pageTitle.value = res.data.page_title
                    dialogFormVisible.value = true
                    formobj.value.map((item) => {
                        if (item.name === 'navtype') {
                            appType.value = item.value
                        }
                    })
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const onSubmit = (obj) => {
                proxy.jiu.request(postUrl.value, obj, 'POST').then((res, rej) => {
                    dialogFormVisible.value = false
                    tablePageRef.value.getDataList(query)
                    proxy.jiu.toast(res.message)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            onMounted(() => {
                tablePageRef.value.getDataList(query)
            })
            const getDataList = (e) => {
                tablePageRef.value.getDataList(query)
            }

            const nodeBut = (e, data, index) => {
                if (e === 'Add') {
                    postUrl.value = urls.add
                    getInfo({ pid: data.id })
                }
                if (e === 'Edit') {
                    postUrl.value = urls.edit
                    getInfo({ id: data.id }, urls.edit)
                }
            }

            const handleSelectionChange = (e) => {
                selectIds.value = e
            }

            const menusToForm = () => {
                menusRef.value.setAppType(appType.value)
                dialogMenusVisible.value = true
            }
            provide('dialogFormVisible', dialogFormVisible)
            provide('dialogMenusVisible', dialogMenusVisible)
            return {
                getDataList,
                topBut,
                nodeBut,
                handleSelectionChange,

                tablePageRef,
                urls,
                addFormRef,
                formTitle,
                noManage,

                isload,
                pageInfo,
                pageTitle,
                formobj,
                onSubmit,

                menusRef,
                menusUrl,
                onUrlChange,
                menusToForm
            }
        }
    })
</script>
<style>
    .database-page .data-table .el-table__body-wrapper {
        height: calc(100vh - 325px);
    }
</style>
